import { useEffect, useState } from "react";

// Returns true on desktop-sized viewports. Used to avoid auto-focusing inputs on
// mobile (which scrolls the page and pops the keyboard on load).
export function useIsDesktop(query = "(min-width: 1024px)") {
  const get = () => typeof window !== "undefined" && window.matchMedia(query).matches;
  const [isDesktop, setIsDesktop] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [query]);
  return isDesktop;
}
